import AdminBadge from "../_components/AdminBadge";
import { cellClass, stickyCellClass } from "../_components/AdminTable";
import AdminRowActions, { DeleteButton, EditLink } from "../_components/AdminRowActions";

const PackageItem = ({
  package: { _id, airport, vehicletype, locations, packagename, rate, isactive },
  count,
  deletePackage,
}) => (
  <tr>
    <td className={cellClass}>{count + 1}</td>
    <td className={cellClass}>{packagename}</td>
    <td className={cellClass}>{airport?.label}</td>
    <td className={cellClass}>
      <div className="tw:flex tw:flex-col tw:gap-1">
        {(locations || []).map((l) => (
          <span key={l?.lat} className="tw:!text-[13px] tw:!text-[#8D8D8D] tw:leading-none">
            {l?.label}
          </span>
        ))}
      </div>
    </td>
    <td className={cellClass}>{vehicletype}</td>
    <td className={cellClass}>{rate}</td>
    <td className={cellClass}>
      <AdminBadge tone={isactive ? "success" : "neutral"}>{isactive ? "Active" : "Inactive"}</AdminBadge>
    </td>
    <td className={stickyCellClass}>
      <AdminRowActions>
        <EditLink to={`/admin/packagelist/edit/${_id}`} label="Edit package" />
        <DeleteButton
          label="Delete package"
          onClick={() => deletePackage(_id)}
        />
      </AdminRowActions>
    </td>
  </tr>
);

export default PackageItem;
